const LegendItem = ({ item }) => (
  <div className={`legend-item ${item}`}>
    <div className={`legend-bullet ${item}`} />
    <span>{item}</span>
  </div>
);

module.exports = LegendItem;
